<template>
	<div class="qromo-report-fiscalization">
		<AppCard title=" " class="mb-20" no-header>
			<template #body>
				<div class="general-drop-head" @click="fiscalizationOpen = !fiscalizationOpen">
					<div class="title">{{ getString('fiscalization_summary') }}</div>
					<AppChevronIcon :direction="fiscalizationOpen ? 'up' : 'down'" />
				</div>
				<div class="general-drop-body">
					<AppDropdown :collapsed="!fiscalizationOpen" white>

						<div class="summaries-container">

							<!-- Fiscal printer -->
							<div class="summary-container" v-if="currentResults.fiscalPrinter > 0 || currentResults.fiscalPrinterPrevious > 0" @click="openFiscalPrinter">
								<div class="summary-head">
									<div class="title">{{ getString('fiscal_printer_receipts') }}</div>
									<div class="value">
										<div class="counter-container">
											<div class="counter-n">N°</div>
											<div class="counter-value">{{ currentResults.fiscalPrinterNum }}</div>
										</div>
										<AppChevronIcon :direction="fiscalPrinterOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!fiscalPrinterOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.fiscalPrinterBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.fiscalPrinter"
													:last-period-value="currentResults.fiscalPrinterPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.fiscalPrinterCards"
													:last-period-value="currentResults.fiscalPrinterCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.fiscalPrinterCash"
													:last-period-value="currentResults.fiscalPrinterCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.fiscalPrinterOther"
													:last-period-value="currentResults.fiscalPrinterOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card" v-if="currentResults.fiscalPrinterCanceledNum > 0">
												<UserInitialCardInfo
													blue :title="getString('canceled_receipts')"
													:value="currentResults.fiscalPrinterCanceledNum"
													:last-period-value="currentResults.fiscalPrinterCanceledNumPrevious"
													:no-currency="true" />
											</div>
											<div class="container-mini-card" v-if="currentResults.fiscalPrinterCanceledValue > 0">
												<UserInitialCardInfo
													blue :title="getString('canceled_receipts')"
													:value="currentResults.fiscalPrinterCanceledValue"
													:last-period-value="currentResults.fiscalPrinterCanceledValuePrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- apiscontrino -->
							<div class="summary-container" v-if="currentResults.apiscontrino > 0 || currentResults.apiscontrinoPrevious > 0" @click="openApiscontrino">
								<div class="summary-head">
									<div class="title">{{ getString('apiscontrino_receipts') }}</div>
									<div class="value">
										<div class="counter-container">
											<div class="counter-n">N°</div>
											<div class="counter-value">{{ currentResults.apiscontrinoNum }}</div>
										</div>
										<AppChevronIcon :direction="apiscontrinoOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!apiscontrinoOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.apiscontrinoBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.apiscontrino"
													:last-period-value="currentResults.apiscontrinoPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.apiscontrinoCards"
													:last-period-value="currentResults.apiscontrinoCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.apiscontrinoCash"
													:last-period-value="currentResults.apiscontrinoCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.apiscontrinoOther"
													:last-period-value="currentResults.apiscontrinoOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- apifattura -->
							<div class="summary-container" v-if="currentResults.apifattura > 0 || currentResults.apifatturaPrevious > 0" @click="openApifattura">
								<div class="summary-head">
									<div class="title">{{ getString('invoices') }}</div>
									<div class="value">
										<div class="counter-container">
											<div class="counter-n">N°</div>
											<div class="counter-value">{{ currentResults.apifatturaNum }}</div>
										</div>
										<AppChevronIcon :direction="apifatturaOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!apifatturaOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.apifatturaBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.apifattura"
													:last-period-value="currentResults.apifatturaPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.apifatturaCards"
													:last-period-value="currentResults.apifatturaCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.apifatturaCash"
													:last-period-value="currentResults.apifatturaCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.apifatturaOther"
													:last-period-value="currentResults.apifatturaOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

						</div>

					</AppDropdown>
				</div>
			</template>
		</AppCard>
	</div>
</template>

<script>
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useAnalyticsStore, usePrintersStore, useUserStore} from "@/console-new/stores";
import UserInitialCardInfo from "@/user/components/analytics/UserInitialCardInfo.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const analyticsStore = useAnalyticsStore();
		const printersStore = usePrintersStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		const svgStore = useSvgStore();
		return {
			getString: languageStore.getString,
			getIcon: svgStore.get,
			userStore,
			analyticsStore,
			printersStore,
			notificationStore,
			currencyStore,
		}
	},
	name: "QromoReportFiscalization" ,
	emits: ['openBreakdown'],
	components: {UserInitialCardInfo, AppButtonIcon, AppCard, AppChevronIcon, AppDropdown},
	data() {
		return {
			fiscalizationOpen: false,
			fiscalPrinterOpen: true,
			apiscontrinoOpen: false,
			apifatturaOpen: false,
		}
	},
	props: {
		currentResults: {type: Object, required: true},
	},
	methods: {
		openFiscalPrinter() {
			this.fiscalPrinterOpen = !this.fiscalPrinterOpen;
			this.apiscontrinoOpen = false;
			this.apifatturaOpen = false;
		},
		openApiscontrino() {
			this.apiscontrinoOpen = !this.apiscontrinoOpen;
			this.fiscalPrinterOpen = false;
			this.apifatturaOpen = false;
		},
		openApifattura() {
			this.apifatturaOpen = !this.apifatturaOpen;
			this.fiscalPrinterOpen = false;
			this.apiscontrinoOpen = false;
		},
	},
}
</script>

<style scoped lang="scss">
.container-mini-cards-total {
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
	--gap-size: 8px;
	gap: var(--gap-size);
	background-color: var(--color-bg);
	border-radius: 13px;
	padding: 10px;
	box-shadow: inset 0 1px 2px var(--color-alpha-4);

	.container-mini-card {
		width: calc(25% - (var(--gap-size)/2) - 2px);
		border: 1px solid transparent;

		.dark-blue {
			background-color: var(--color-bg-primary-2);
			border: 1px solid var(--color-primary);
			cursor: pointer;
		}

		@media (max-width: 1439px) {
			width: calc(50% - (var(--gap-size)/4) - 2px);
		}

		@media (max-width: 500px) {
			width: 100%;
		}
	}
}
.general-drop-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 12px;
	background-color: var(--color-bg-primary-3);
	border-radius: 13px;
	cursor: pointer;

	.title {
		font-size: 16px;
		font-weight: 500;
	}
}
.general-drop-body {

	:deep(.dropdown-content) {
		box-shadow: none !important;
		padding: 0 !important;
	}

	.summaries-container {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.summary-container {
		background-color: var(--color-bg-primary-2);
		border-radius: 13px;
		padding: 10px 11px;
		border: 1px solid var(--color-alpha-4);
		cursor: pointer;

		.summary-head {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.title {
				font-size: 16px;
				font-weight: 500;
			}

			.value {
				display: flex;
				align-items: center;
				gap: 8px;
				font-size: 14px;
				color: var(--color-txt-1);

				.counter-wrapper {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					gap: 4px;

					@media (max-width: 500px) {
						flex-direction: column-reverse;
						align-items: flex-end;
						justify-content: center;
					}
				}

				.counter-container {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 4px;
					font-size: 14px;
					color: var(--color-txt-1);
					background-color: var(--color-bg-primary-1);
					border-radius: 7px;
					padding: 8px;
					box-shadow: inset 0 1px 2px var(--color-alpha-4);
					min-width: 65px;

					&:deep(svg) {
						width: 12px;
						height: 12px;

						.fill {
							fill: var(--color-txt-1);
						}

						.stroke {
							stroke: var(--color-txt-1);
						}
					}

					.counter-value {
						font-weight: 700;
					}
					.counter-n {
						display: flex;
						align-items: center;
					}
				}
			}

		}
	}
}
</style>